import {User} from '../../model/security/user';
import {CurrentUserInfo} from '../../model/security/current-user-info';
import {Token} from '../../model/security/token';
// @ts-ignore
import {DateTime} from 'luxon';
import {Support} from '../../model/support';
import {ClassType} from '@hyperloris/tyson/dist/types/reflect/typeToken';
import {PasswordSecurity} from '../../model/security/password-security';
import {CrystalclearHealth} from "../../model/crystalclear-health";
import {ApiValidation} from "../../model/api/api-validation";
import {ConversionRate} from 'src/app/model/hogo-conversion-rate';
import {Calculate} from 'src/app/model/hogo-calculate';

export class CrystalclearBackUrl {
  static readonly LOGIN: CrystalclearBackUrl.UrlConf<ApiValidation<Token>> = {
    url: '/api/users/login',
    type: ApiValidation
  };

  static readonly GET_CURRENT_USER: CrystalclearBackUrl.UrlConf<CurrentUserInfo> = {
    url: '/api/users/me',
    type: CurrentUserInfo
  };

  static readonly LOGOUT: CrystalclearBackUrl.UrlConf<any> = {
    url: '/api/users/logout',
    type: Object
  };

  // @ts-ignore
  static readonly POST_SUPPORT_MAIL: CrystalclearBackUrl.UrlConf<Support> = {
    url: '/api/support/support',
    type: Support
  };

  // @ts-ignore
  static readonly POST_PASSWORD_MAIL: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/users/send-mail',
    type: ApiValidation
  };

  // @ts-ignore
  static readonly POST_PASSWORD_RECOVERY: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/users/change-password',
    type: ApiValidation
  };

  // @ts-ignore
  static readonly POST_PASSWORD_RESET: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/users/reset-password',
    type: ApiValidation
  };

  // @ts-ignore
  static readonly GET_PASSWORD_SECURITY: CrystalclearBackUrl.UrlConf<PasswordSecurity> = {
    url: '/api/users/password-security',
    type: PasswordSecurity
  };

  // @ts-ignore
  static readonly GET_CRYSTALCLEAR_HEALTH: CrystalclearBackUrl.UrlConf<CrystalclearHealth> = {
    url: '/api/health/ping',
    type: CrystalclearHealth
  };

  //USER TOOLS
  static readonly HOGO_CALCULATE: CrystalclearBackUrl.UrlConf<Calculate> = {
    url: '/api/user-tools/hogo/calculate',
    type: Calculate
  };
  static readonly HOGO_CONVERSION_RATE: CrystalclearBackUrl.UrlConf<ConversionRate> = {
    url: '/api/user-tools/hogo/conversion-rate',
    type: ConversionRate
  }
}

export module CrystalclearBackUrl {
  export class UrlConf<T> {
    url: string = '';
    type: ClassType<T> | undefined;
  }
}
